//Generated File 
export default class NestConstants{
	static readonly ACTIVE_ELEMENT = `activeEl`;
	static readonly CALL_GUI_ACTION = `c$g$a`;
	static readonly CHANGE_DIMENSIONS = `changeDimensions`;
	static readonly COLUMN_IS_NOT_ENABLED = `@@Field is not enabled`;
	static readonly COULD_NOT_FIND_COLUMN = `@@Could not find column `;
	static readonly COULD_NOT_FIND_FIELD = `@@Could not find field `;
	static readonly COULD_NOT_PERFORM_GRID_ACTION = `@@Could not perform grid action `;
	static readonly ERRORS_SEP = `m$%$^**()kJ)(*`;
	static readonly FETCH_ERRORS = `fetchErrors`;
	static readonly FIELD_IS_NOT_ENABLED = `@@Field is not enabled`;
	static readonly FIND_COLUMN_PAGE = `findColumnPage`;
	static readonly FIND_FIELD_PAGE = `findFieldPage`;
	static readonly HASH_CODE = `#code`;
	static readonly HASH_ENTITY_TYPE = `#entityType`;
	static readonly HASH_REFERENCE_NAME = `@name`;
	static readonly HASH_TYPE = `#type`;
	static readonly HASH_VALUE = `#value`;
	static readonly INDICATORS = `indicators`;
	static readonly INITIALIZING_PLACES = `initializingPlaces`;
	static readonly MARK_DB_STATE = `getBizServerTime`;
	static readonly NAMA_ACTIONS_PERFORMER = `namaActionsPerformer`;
	static readonly NAMA_ADD_CRITERIA = `namaAddCriteria`;
	static readonly NAMA_COLUMNS_SETTER = `namaColumnsSetter`;
	static readonly NAMA_FIELDS_SETTER = `namaFieldsSetter`;
	static readonly NAMA_GET_CURRENT_STATE = `namaGetCurrentState`;
	static readonly NAMA_GET_STATE_OF_COLUMN = `namaGetStateOfColumn`;
	static readonly NAMA_GET_STATE_OF_FIELD = `namaGetStateOfField`;
	static readonly NAMA_GET_VALUE_OF_COLUMN = `namaGetValueOfColumn`;
	static readonly NAMA_GET_VALUE_OF_FIELD = `namaGetValueOfField`;
	static readonly NAMA_OPEN_LIST_WIDGET = `namaOpenListWidget`;
	static readonly NAMA_OPEN_PAGE = `namaOpenPage`;
	static readonly NAMA_PERFORM_GRID_ACTION = `namaPerformGridAction`;
	static readonly NAMA_SET_ORDER_BY = `namaSetOrderBy`;
	static readonly NEST_ACTIVE_COOKIE = `nestACtive`;
	static readonly NO_ACTIVE_WINDOW = `@@No active window open`;
	static readonly REVERT_TO_DB_STATE = `srIoMPsQRTorsd`;
	static readonly SCHEDULED_TASKS_COUNT = `scheduledTasksCount`;
	static readonly SERVER_TIME_STAMP = `bizServerTime`;
	static readonly VALUES_SEP = `|`;
	static readonly WAITING = `waiting`;
}
